<template>
  <section>
    <p>Rated by <strong>peers</strong>. How do you compare?</p>
    <ol>
      <li v-for="(blast, index) in top10" :class="{active: blast.isOpen}">
        <div class="upper">
          <div>
            <span class="rank">{{ blast.rank }}.</span>
            <button @click.prevent="blast.isOpen = !blast.isOpen" class="nickname">
              {{ blast.name || "Anonymous" }}
              <sprite name="iconDownDir" class="down-arrow" />
            </button>
          </div>
          <span class="score">{{ blast.score | blastScore }}</span>
        </div>
        <blockquote v-if="blast.isOpen">{{ blast.post }}</blockquote>
      </li>
    </ol>
  </section>
</template>

<script>

  export default {
    name: 'BlastTop10',
    props: {
      blast: {
        type: Object,
        required: true
      }
    },
    data () {
      const top10 = this.blast.blastPrompt.question.top
      const ranks = _.map(top10, "score")
      return {
        top10: _.map(top10, (top, index) => {
          return _.assign({}, top, {rank: _.indexOf(ranks, top.score)+1, isOpen: index<3})
        })
      }
    },
    filters: {
      blastScore: function (value) {
        return value.toFixed(3)
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

  ol {
    @include list-style-reset
  }

  li {
    @include font-size(xlarge);
    margin-top:2rem; padding:2rem; background-color:$color-white; border-radius:4px; box-shadow:0 4px 12px 0 $color-gray-lighter;
  }

  .rank {
    margin-right:.5em;
  }

  .upper {
    display:flex;
    > div {
      flex:2;
    }
  }

  .nickname {
    @include font-size(large);
  }

  .down-arrow {
    @include transition();
    @include size(1.5rem);
    transform:rotate(-90deg);
    li.active & {
      transform:rotate(0);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/blast-top-10.vue